// "Spot the Slip" expansion — DAILY ROUTINE theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_DAILY_ROUTINE = [
  ["Hoy soy muy ocupado y no puedo salir.", "Hoy estoy muy ocupado y no puedo salir.", "ser-estar",
    "Being busy today is a passing state → estar.", "ser-vs-estar"],
  ["Por las mañanas soy cansado hasta el café.", "Por las mañanas estoy cansado hasta el café.", "ser-estar",
    "Tiredness at a given moment is a condition → estar.", "ser-vs-estar"],
  ["Mi horario de trabajo es muy regular.", "Mi horario de trabajo es muy regular.", "ser-estar",
    "Trap check: a defining feature of the schedule correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Pongo el despertador a las seis cada día.", "Pongo el despertador a las seis cada día.", "ser-estar",
    "Trap check: this sentence is already fully correct — no slip here.", "ser-vs-estar"],
  ["Tengo un rutina muy estricta.", "Tengo una rutina muy estricta.", "gender",
    "Rutina is feminine → una rutina.", "gender-agreement-of-nouns"],
  ["La fin de semana descanso en casa.", "El fin de semana descanso en casa.", "gender",
    "Fin is masculine → el fin de semana.", "gender-agreement-of-nouns"],
  ["Llevo una ritmo muy tranquilo.", "Llevo un ritmo muy tranquilo.", "gender",
    "Ritmo is masculine → un ritmo.", "gender-agreement-of-nouns"],
  ["A mí me gusta las mañanas tranquilas.", "A mí me gustan las mañanas tranquilas.", "gustar",
    "Plural mornings liked → gustan.", "gustar-and-similar-verbs"],
  ["Me da pereza los lunes por la mañana.", "Me dan pereza los lunes por la mañana.", "gustar",
    "Dar pereza agrees with the plural Mondays → dan.", "gustar-and-similar-verbs"],
  ["Salí temprano para llegar a tiempo al trabajo.", "Salí temprano para llegar a tiempo al trabajo.", "por-para",
    "Trap check: purpose ('in order to arrive') correctly uses para. (Already correct!)", "por-vs-para"],
  ["Estudio español por la mañana por mejorar.", "Estudio español por la mañana para mejorar.", "por-para",
    "Goal or purpose ('in order to improve') takes para.", "por-vs-para"],
  ["Cuando era estudiante, me levanté siempre tarde.", "Cuando era estudiante, me levantaba siempre tarde.", "preterito-imperfecto",
    "A repeated past habit is imperfecto → me levantaba.", "a2-preterito-vs-imperfecto"],
  ["Me levanto a las seis y desayuno rapido.", "Me levanto a las seis y desayuno rápido.", "accents",
    "Rápido is esdrújula, so it always carries a written accent.", "stress-and-written-accents"],
  ["Quiero que mi rutina es más sana.", "Quiero que mi rutina sea más sana.", "subjunctive",
    "A wish about your routine (querer que) triggers the subjunctive → sea.", "b1-present-subjunctive"],
  ["Es necesario que duermes ocho horas.", "Es necesario que duermas ocho horas.", "subjunctive",
    "Impersonal 'es necesario que' takes the subjunctive → duermas.", "b1-present-subjunctive"],
];
